import { Injectable } from '@angular/core';
import { DocumentFeatures, WidgetContext } from '@core/model/widget-configuration.model';


@Injectable({
  providedIn: 'root'
})
export class PlatformService {
  private context: WidgetContext;
  private _lineOfBusiness: string;
  private features: Partial<Record<DocumentFeatures, boolean>> = {};

  set widgetContext(value: WidgetContext) {
    this.context = value;
  }

  get widgetContext() {
    return this.context;
  }

  set lineOfBusiness(value: string) {
    this._lineOfBusiness = value;
  }

  get lineOfBusiness() {
    return this._lineOfBusiness;
  }

  set widgetFeatures(value: Partial<Record<DocumentFeatures, boolean>>) {
    this.features = value;
  }

  get widgetFeatures() {
    return this.features;
  }
}
